export default __webpack_public_path__ + "static/pulse_answer_bank-519dbbd332c9c6dbaca0260a457341d3.jpeg";